import { AGENT_INTEGRATIONS } from '@nimblybase/contracts'

type HostId = typeof AGENT_INTEGRATIONS.hosts[number]['id']
type Setup = { install: string; restart: string }

/** Host instructions describe a test route, never proof that this user has installed it. */
export const INTEGRATION_SETUP = {
  claude: {
    install: 'Open the supplied Claude Code bundle with --plugin-dir, or install it from your tester marketplace. The Claude Desktop connector is a separate route.',
    restart: 'Start a new Claude Code session and check that the NimblyBase skill and MCP server appear.',
  },
  codex: {
    install: 'Add the supplied bundle to a local or repository marketplace, then install and enable it in the plugin browser. Use the instructions for your desktop or CLI version.',
    restart: 'Start a new Codex chat with the plugin enabled. Desktop and CLI connections must be checked separately.',
  },
  cursor: {
    install: 'Copy the supplied bundle into ~/.cursor/plugins/local/nimblybase-uat. Your team may need an administrator to allow local plugin imports.',
    restart: 'Reload the Cursor window, open Customize and check the NimblyBase skill and MCP server.',
  },
  openclaw: {
    install: 'Install the supplied bundle using openclaw plugins install with its local directory or archive. Use an isolated personal agent for this test; shared channels are not approved.',
    restart: 'Inspect the plugin with openclaw plugins inspect, then start a new session. A capability reported as not wired is unavailable.',
  },
  grokbot: {
    install: 'In a personal Grok Bot, ask it to prepare a Remote HTTPS MCP connection named NimblyBase UAT, using the address below. Review the definition before adding it; adding the definition does not authorize access.',
    restart: 'Use its browser authorization flow, then type @ in chat and select the exact connected NimblyBase account. Text that only names the connector does not attach it.',
  },
  hermes: {
    install: 'Install the supplied portable bundle through the Hermes plugin workflow, then explicitly enable it with hermes plugins enable. Installation alone leaves portable packages disabled.',
    restart: 'Start a new session or reload MCP connections. Remote OAuth and the complete application journey still need testing.',
  },
  qoder: {
    install: 'Install the supplied bundle from its local directory using qoder plugins install. The Qoder IDE plugin route is separate and must be tested independently.',
    restart: 'Use the plugin explorer to check enablement and reload plugins. Confirm the NimblyBase skill and MCP server appear.',
  },
} satisfies Record<HostId, Setup>

export const CONNECTION_VERIFY_PROMPT = 'Use NimblyBase tools to identify the workspace authorized for this connection and list its existing projects. Do not create or change anything.'

export const GROK_CONNECTION_VERIFY_PROMPT = 'Using only the attached NimblyBase connection, call list_organizations and list_projects. Report the workspace, server-resolved clientId, projectId and granted scopes. Do not create or change anything, switch accounts, or fall back to a CLI login or copied token.'
